import React from "react";
import { TextField, Grid, Box, Checkbox, FormControlLabel } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { matchSorter } from "match-sorter";
import AuraControlledMultiSelectAutocomplete from "./AuraControlledMultiSelectAutocomplete";
import AuraControlledAutocomplete from "./AuraControlledAutocomplete";
import { withoutKey } from 'app/main/apps/common/optionProps';

const CustomExportContent = (props) => {
  const { customersListItems, salesPersonListItems, suppliersListItems } =
    props;
  const parentFilterType = props?.params?.parentFilterType ?? "customer";

  const methods = useFormContext();
  const { control } = methods;

  /**
   * To check Export All is currently selected
   */
  function isCustomerExport() {
    return parentFilterType === "customer";
  }
  /**
   * To check Export All is currently selected
   */
  function isSupplierExport() {
    return parentFilterType === "supplier";
  }

  return (
    <>
      <Grid container spacing={3} className="pt-12">
        {/* From Date */}
        <Grid item xs={12}>
          <Controller
            name="start_date"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="From Date"
                type="date"
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </Grid>

        {/* To Date */}
        <Grid item xs={12}>
          <Controller
            name="end_date"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="To Date"
                type="date"
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </Grid>

        {/* Sales Person */}
        {isCustomerExport() && (
          <Grid item xs={12}>
            <AuraControlledAutocomplete
              control={control}
              controlName="sales_person"
              inputValues={
                salesPersonListItems?.length > 0 ? salesPersonListItems : []
              }
              labelName="Sales Person"
              className="my-0"
              renderOption={(renderprops, option) => {
                const isSelected =
                  control._formValues.sales_person?.id === option.id;

                return (
                  <Box
                    component="li"
                    {...withoutKey(renderprops)}
                    key={option.id}
                    className={`flex-column py-2 px-4 hover:bg-gray-100 ${
                      isSelected && "!bg-[#e3f2fd]"
                    }`}
                  >
                    <div className="font-medium ml-8">{option.name}</div>
                    <div className="font-light text-10 text-gray-600  ml-8">
                      {option.email}
                    </div>
                  </Box>
                );
              }}
              filterOptions={(options, { inputValue }) =>
                matchSorter(options, inputValue, {
                  keys: ["name"],
                  threshold: matchSorter.rankings.STARTS_WITH,
                })
              }
            />
          </Grid>
        )}

        {/* Customers Multi-select */}
        {isCustomerExport() && (
          <Grid item xs={12}>
            <AuraControlledMultiSelectAutocomplete
              controllerName="customers"
              control={control}
              options={
                customersListItems?.length >= 0 ? customersListItems : []
              }
              label="Customers"
              showSelectAll={false}
              className="w-full"
              listItemStyle="withSecondaryText"
            />
          </Grid>
        )}

        {/* Checkboxes */}
        {isCustomerExport() && (
        <Grid item xs={12}>
          <Box display="flex" flexDirection="column">
            <Controller
              name="include_invoice"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={<Checkbox {...field} checked={field.value || false} />}
                  label="Include Invoice"
                />
              )}
            />
            <Controller
              name="include_archive"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={<Checkbox {...field} checked={field.value || false} />}
                  label="Include Archive"
                />
              )}
            />
          </Box>
        </Grid>
        )}

        {/* Suppliers Multi-select */}
        {isSupplierExport() && (
          <Grid item xs={12}>
            <AuraControlledMultiSelectAutocomplete
              controllerName="suppliers"
              control={control}
              options={
                suppliersListItems?.length >= 0 ? suppliersListItems : []
              }
              label="Suppliers"
              showSelectAll={false}
              className="w-full"
              listItemStyle="withSecondaryText"
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default CustomExportContent;
